import RacsTesztlapDto from 'app/admin/racstesztlap/dto/RacsTesztlapDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';

class RacsTesztlapTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'tesztlapGridDetectionTableControl';
	}

	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, RacsTesztlapDto)))
				.catch(reject);
		});
	}
}

export default new RacsTesztlapTableService();
